import { NotificacaoLogListTable } from "../components/NotificacaoLogListTable";

export function HistoricoTab() {
  return <NotificacaoLogListTable />;
}
